import { useRef } from "react";
import "../CSS/SpotlightCard.css";

const SpotlightCard = ({
  children,
  className = "",
  spotlightColor = "rgba(0,229,255,0.6)"
}) => {

  const divRef = useRef(null);

  const handleMouseMove = (e) => {
    const rect = divRef.current.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    divRef.current.style.setProperty("--mouse-x", `${x}px`);
    divRef.current.style.setProperty("--mouse-y", `${y}px`);
    divRef.current.style.setProperty("--spotlight-color", spotlightColor);
  };

  return (
    <div
      ref={divRef}
      className={`card-spotlight ${className}`}
      onMouseMove={handleMouseMove}
      onMouseEnter={handleMouseMove}
    >
      {children}
    </div>
  );
};

export default SpotlightCard;